<template>
  <div class="page" @touchmove.prevent>
    <div class="bg-window"></div>
    <div class="main">
      <!-- <div class="title">3天CP·爱在进行时</div> -->
      <img class="pic-title" src="https://static.huiyiji520.com/cppic-1661943120.png">
      <div class="entries">
        <div class="entry flex-box" @click="getMatchResult()">匹配结果</div>
        <!-- <div class="entry flex-box">个人中心</div> -->
        <div class="entry flex-box" @click="modifyForm()">修改报名</div>

        <!-- <div v-if="$store.state.userinfo.level == 'membership'" class="entry flex-box" @click="goBought()">购买记录</div> -->
      </div>

      <van-popup class="pop" v-model="showPop" round position="center" :close-on-click-overlay="false">
        <div>
          <!-- <div class="ptitle">报名成功</div> -->
          <img class="pic-ptitle" src="https://static.huiyiji520.com/cppic-1661235465.png">
          <img class="qrcode" src="https://static.huiyiji520.com/cppic-1661861574.jpeg">
          <div class="hints">
            <div class="hint">↑长按识别上方二维码</div>
            <div class="hint">关注公众号：<span class="account">浪漫员Club</span></div>
            <div class="hint">即可查看CP匹配结果</div>
            <div class="hint small">匹配结果公布日期：<span class="date">{{$store.state.timeLookup}}</span></div>
            <!-- <div class="hint">请在<span class="date"> 2022年9月7日 </span>晚19点</div>
            <div class="hint">在公众号：<span class="account">浪漫员Club</span></div>
            <div class="hint">回复【<span class="keyword">结果</span>】查看匹配结果</div> -->
            <!-- <div class="hint small">↑点击上方蓝字即可直接关注公众号</div> -->
          </div>
          <!-- <div class="btn-confirm" @click="confirmSubmit()">确认</div> -->
        </div>
      </van-popup>

    </div>
  </div>
</template>

<script>
import { Toast, Popup } from 'vant'

export default{
  components: {
    [Toast.name]: Toast,
    [Popup.name]: Popup
  },
  data(){
    return {
      showPop: false
    }
  },
  methods: {
    handleRouter(path){
      this.$router.push(path)
    },
    goBack(){
      this.$router.back()
    },
    getMatchResult(){
      let timeLookup = this.$store.state.timeLookup
      let stage = this.$store.state.currentStage
      if(stage == "enrolling" || stage == "matching" || stage == "matched"){
        Toast(`${timeLookup}开放查询本期匹配结果`)
      }else if(stage == "lookuping"){
        this.handleRouter('/match_result')
      }else{
        Toast("当前时间不可查询")
      }
    },
    modifyForm(){
      //this.handleRouter('/choose_me_sex')
      let timeLookup = this.$store.state.timeLookup
      let stage = this.$store.state.currentStage
      if(stage == "enrolling"){
        this.$router.replace('/choose_me_sex')
      }else if(stage == "matching" || stage == "matched"){
        Toast('正在匹配中，当前不可修改～')
      }else{
        Toast('匹配已结束，当前不可修改～')
      }
    },
    // checkSubscribe(){
    //   if(this.$store.state.userinfo.subscribe != 1){
    //     this.showPop = true
    //   }
    // },
    getSubscribeAndForm(){
      let openid = this.$store.state.userinfo.openid
      let issue = this.$store.state.issue
      let _this = this
      this.$api.get('/couple/get_form_detail', {openid: openid, issue: issue}, res => {
        if(res.code == 200){
          this.showPop = res.userinfo.subscribe == 1 ? false : true
          if(res.form.valid == "ok"){
            let cpchoose = _this.$store.state.cpchoose
            cpchoose.fid = res.form.fid
            cpchoose.mySex = res.form.sex
            cpchoose.myBirth = res.form.birth
            cpchoose.myProvince = res.form.province
            cpchoose.myCity = res.form.city
            cpchoose.myJob = res.form.job
            cpchoose.myEducation = res.form.education
            cpchoose.myIntro = res.form.intro
            cpchoose.myTags = res.form.tags
            cpchoose.myPhone = res.form.phone
            cpchoose.myWechat = res.form.wechat
            cpchoose.partnerSex = res.form.cp_sex
            cpchoose.partnerAge = res.form.cp_age
            cpchoose.partnerCity = res.form.cp_city
            cpchoose.partnerJob = res.form.cp_job
            cpchoose.partnerSurprise = res.form.cp_surprise
            this.$store.commit('updateCpChoose', cpchoose)
          }
        }
      })
    },
    goLangClub(){
      // let url = "https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=Mzg5Njg0MjQyMA==&scene=123#wechat_redirect"
      let url = "https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=Mzg5Njg0MjQyMA==&scene=123&from=singlemessage#wechat_redirect"
      window.location.href = url
    },
    goBought(){
      this.handleRouter('/bought')
    }
  },
  mounted(){
    this.getSubscribeAndForm()
  }
}
</script>

<style scoped>
.page{min-height:100vh;}
.bg-window{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-image: url("https://static.huiyiji520.com/cppic-1661178650.png");
  background-size:100% 100%;
  background-repeat:no-repeat;
  /* opacity:0.1; */
  z-index:-1;
}
.main{text-align:center;}
.main .title{margin-top:200px;margin-bottom:113px;font-size:70px;color:#eb8e80;}
.main .pic-title{width:202px;height:65px;margin:0 auto;margin-top:207px;margin-bottom:250px;}
/* .main .entries{margin-top:186px;} */
.main .entries .entry{
  width:342px;height:100px;font-size:40px;border:5px solid #f1b8af;border-radius:25px;
  margin:0px auto;color:#ffffff;background:#f1b8af;justify-content:center;
  margin-bottom:83px;
}
.main .pop{width:600px;padding:50px;}
.main .pop .ptitle{font-size:78px;color:#eb8e80;margin-top:50px;}
.main .pop .pic-ptitle{width:276px;height:69px;margin:0 auto;margin-top:50px;}
.main .pop .qrcode{width:280px;display:block;margin:0 auto;margin-top:20px;margin-bottom:20px;}
.main .pop .hints{font-size:32px;color:#545454;}
.main .pop .hints .hint{margin-bottom:15px;}
.main .pop .hints .hint.small{font-size:24px;padding-top:5px;color:#737373;}
.main .pop .date{color:#eb8e80;font-weight:bold;}
.main .pop .account{color:#67a1f0;font-weight:bold;}
.main .pop .keyword{color:#eb8e80;}
.main .pop .btn-confirm{
  background:#f1b8af;color:#fff;font-size:32px;width:180px;margin:0 auto;padding:10px;
  border-radius:25px;margin-top:48px;font-weight:bold;
}
</style>
